import React from 'react';
import {connect} from 'react-redux';
import { Button, List, message, Popconfirm } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import SettingsAction from '../../redux/SettingsActions';
import i18n from "i18next";

//  см. https://ant.design/components/list/
class NamespaceRepository extends React.Component {

  constructor(props, context) {
    super(props, context)
    this.state = {
      loading: false, 			//Флаг загрузки
      namespaces: [],
    }    
  }
  
  componentDidMount() {
    const {namespaces} = this.state;
    if (namespaces.length < 1)
      this.loadFirst();
  }
    

  /** Метод начального считывания, когда offset=0. Разница в получении количества записей */
  loadFirst = () => {
    this.setState({loading: true});
    this.props.dispatch(SettingsAction.loadNamespaces())
      .then ((response) =>{
        this.setState({loading: false, namespaces: response}, () => { window.dispatchEvent(new Event('resize')); });
      })
      .catch(e => { 
        message.error(`Ошибка получения данных. ${e}`);
        this.setState({loading: false})
      });
  }

  deleteNamespace = (namespace) => {
    this.setState({loading: true});
    this.props.dispatch(SettingsAction.deleteNamespace(namespace))
      .then(() => {
        message.success(`Namespace ${namespace} deleted.`);
        return this.loadFirst();
      })
      .catch(e => {
        message.error(`Namespace deletion failed. ${e}`);
        this.setState({loading: false});
      });
  }

    render() {
      const { loading  } = this.state;
      const { namespaces } = this.props;
      return (
        <>
          <div style={{
            display: 'grid',
            gridTemplateColumns: '14rem minmax(0, 1fr) auto',
            gap: '16px',
            padding: '8px 12px',
            fontWeight: 600
          }}>
            <span>Prefix</span>
            <span>URI</span>
          </div>
          <List
            className="demo-loadmore-list adms_category_div csi_spoiler active"
          loading={loading}
          itemLayout="horizontal"
          dataSource={namespaces}
          renderItem={(item, index) => (
            <List.Item
              style={{
                padding: '8px 12px',
                backgroundColor: index % 2 === 0 ? '#fafafa' : '#ffffff'
              }}
            >
              <div style={{
                display: 'grid',
                gridTemplateColumns: '14rem minmax(0, 1fr) auto',
                alignItems: 'center',
                gap: '16px',
                width: '100%'
              }}>
                <span style={{fontFamily: 'monospace', fontWeight: 600}}>{item.ns}</span>
                <span style={{overflowWrap: 'anywhere'}}>{item.uri}</span>
                <Popconfirm
                  title="Delete namespace?"
                  okText="Delete"
                  cancelText="Cancel"
                  onConfirm={() => this.deleteNamespace(item.ns)}
                >
                  <Button danger icon={<DeleteOutlined />} aria-label={`Delete ${item.ns}`} />
                </Popconfirm>
              </div>
            </List.Item>
          )}
          />
        </>
      );
    }
  }
  
  function mapStateToProps(state, props) {
    return {
    };
  }
  
  export default connect(mapStateToProps)(NamespaceRepository);